module.exports = "https://cdn.littlereply.com/tt/resource/pic_error.ee76175bc64a83d1a79adb5176cff916.png";